import { AxiosInstance } from 'axios'
import { useMutation, useQueryClient } from 'react-query'

import { User, UserSearchResult } from '@dc-shared-web/hooks/api/user'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

import { useToast } from '@dc-shared-web/components/shadcn/use-toast'

type RemoveUserFromTeamParams = {
  userUUID: string
  teamUUID: string
}

const removeUserFromTeam = async (
  apiClient: AxiosInstance,
  params: RemoveUserFromTeamParams
): Promise<unknown> => {
  const { data } = await apiClient.delete(
    `/api/users/${params.userUUID}/teams/${params.teamUUID}`
  )
  return data.data
}

export const useRemoveUserFromTeam = (successMessage?: string) => {
  const apiClient = useAxiosContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation(
    (params: RemoveUserFromTeamParams) => removeUserFromTeam(apiClient, params),
    {
      onSuccess: async (_, params: RemoveUserFromTeamParams) => {
        await queryClient.invalidateQueries<User>(`user-${params.userUUID}`, {
          refetchActive: true,
          refetchInactive: true,
        })
        await queryClient.invalidateQueries<UserSearchResult>({
          queryKey: ['searchUser'],
          refetchPage: (page) => {
            return Boolean(page.data.find((e) => e.uuid === params.userUUID))
          },
        })

        if (successMessage) {
          toast({
            variant: 'success',
            title: successMessage,
          })
        }
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error updating user',
          description: 'If the issue persists, please contact support.',
        })
      },
    }
  )
}
